import { SEARCH_TERM, TEXT_SEARCH } from '../constants';
import getFilterValueFromQuery from './get-filter-value-from-query';
import { buildQueryKey } from '../../../helpers';

const getInitialFilterValues = (filterData, filters, query, listComponentName) => {
  const filterValues = {};
  const searchQueryKey = buildQueryKey(SEARCH_TERM, listComponentName);
  filterValues[SEARCH_TERM] = query[searchQueryKey] || '';

  filters.forEach(filterProps => {
    const {
      propsToDisplay: [key],
      type
    } = filterProps;
    if (type === TEXT_SEARCH) return;
    const data = filterData && filterData[key] ? filterData[key] : {};
    const queryKey = buildQueryKey(key, listComponentName);
    filterValues[key] = getFilterValueFromQuery(queryKey, filterProps, data, query);
  });

  return filterValues;
};

export default getInitialFilterValues;
